import { render, staticRenderFns } from "./user_avatar.vue?vue&type=template&id=c7fe0b9c&scoped=true&"
import script from "./user_avatar.vue?vue&type=script&lang=js&"
export * from "./user_avatar.vue?vue&type=script&lang=js&"
import style0 from "./user_avatar.vue?vue&type=style&index=0&id=c7fe0b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe0b9c",
  null
  
)

export default component.exports